import React from 'react'
import PlanDetails from './planDetails'
const DesignerPlan = () => {
  return <PlanDetails planListPath='getDesignerPlans' designerPlan= {true} createPath='addDesignerPlan' updatePath='updateDesignerPlan' benifitCollection="nq-designer-plan-benefit-masters"/>
}

export default DesignerPlan